import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

const CUSTOMER_INTERACTIONS_MESSAGES_BASE_ENDPOINT = "v2/customer-interactions/messages";

@Injectable({
	providedIn: "root",
})
export class CustomerInteractionsConfigService {
	private readonly enabledTriggers: Map<string, boolean> = new Map<string, boolean>();

	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {
		this.initializeConfiguration();
	}

	getMarkAsShownEndpoint() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.endpoints?.markAsShown,
			`${CUSTOMER_INTERACTIONS_MESSAGES_BASE_ENDPOINT}/:messageId/displayed`
		);
	}

	getMarkAsAcknowledgedEndpoint() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.endpoints?.markAsAcnkowledged,
			`${CUSTOMER_INTERACTIONS_MESSAGES_BASE_ENDPOINT}/:messageId/acknowledged`
		);
	}

	getUnacknowledgedMessagesEndpoint() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.endpoints?.getAllUnacknlowedged,
			`${CUSTOMER_INTERACTIONS_MESSAGES_BASE_ENDPOINT}/unacknowledged`
		);
	}

	isTriggerEnabled(topic: string): boolean | undefined {
		return this.enabledTriggers.get(topic);
	}

	private initializeConfiguration() {
		this.enabledTriggers.set(
			this.getCustomerInteractionsTimeTriggerTopic(),
			this.getCustomerInteractionsTimeTriggerEnabled()
		);
		this.enabledTriggers.set(
			this.getCustomerInteractionsToolsTriggerTopic(),
			this.getCustomerInteractionsToolsTriggerEnabled()
		);
		this.enabledTriggers.set(
			this.getCustomerInteractionsWageringTriggerTopic(),
			this.getCustomerInteractionsWageringTriggerEnabled()
		);
		this.enabledTriggers.set(
			this.getCustomerInteractionsLossTriggerTopic(),
			this.getCustomerInteractionsLossTriggerEnabled()
		);
		this.enabledTriggers.set(
			this.getCustomerInteractionsDepositTriggerTopic(),
			this.getCustomerInteractionsDepositTriggerEnabled()
		);
	}

	private getCustomerInteractionsTimeTriggerEnabled() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.timeTrigger?.isEnabled,
			false
		);
	}

	private getCustomerInteractionsTimeTriggerTopic() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.timeTrigger?.topic,
			"time-trigger"
		);
	}

	private getCustomerInteractionsToolsTriggerEnabled() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.toolsTrigger?.isEnabled,
			false
		);
	}

	private getCustomerInteractionsToolsTriggerTopic() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.toolsTrigger?.topic,
			"tools-trigger"
		);
	}

	private getCustomerInteractionsWageringTriggerEnabled() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.wageringTrigger?.isEnabled,
			false
		);
	}

	private getCustomerInteractionsWageringTriggerTopic() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.wageringTrigger?.topic,
			"wagering-trigger"
		);
	}

	private getCustomerInteractionsLossTriggerEnabled() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.lossTrigger?.isEnabled,
			false
		);
	}

	private getCustomerInteractionsLossTriggerTopic() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.lossTrigger?.topic,
			"loss-trigger"
		);
	}

	private getCustomerInteractionsDepositTriggerEnabled() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.depositTrigger?.isEnabled,
			false
		);
	}

	private getCustomerInteractionsDepositTriggerTopic() {
		return this.service.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.depositTrigger?.topic,
			"deposit-trigger"
		);
	}
}
